import { parseAsInteger, parseAsString, useQueryStates } from 'nuqs';

export const useBatchSearchQueryStates = () => {
  return useQueryStates({
    batchType: parseAsString,
    createdAtFrom: parseAsString,
    createdAtTo: parseAsString,
    page: parseAsInteger.withDefault(1),
  });
};
